import styled from 'styled-components';
import logo from '../../img/logo.png';
import squareLogo from '../../img/square-logo.png';
var Logo = styled.img.attrs({
  src: function src(props) {
    return props.shape === 'square' ? squareLogo : logo;
  }
}).withConfig({
  displayName: "Logo",
  componentId: "ikrvav-0"
})(["height:", ";"], function (props) {
  return (props.height ? props.height : '60') + 'px';
});
export default Logo;